import { render, staticRenderFns } from "./ChangeEmailOtp.vue?vue&type=template&id=6dcb98ac&scoped=true"
import script from "./ChangeEmailOtp.vue?vue&type=script&lang=js"
export * from "./ChangeEmailOtp.vue?vue&type=script&lang=js"
import style0 from "./ChangeEmailOtp.vue?vue&type=style&index=0&id=6dcb98ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcb98ac",
  null
  
)

export default component.exports